import { theme } from '@faxi/web-component-library';
import { flex, fontSize, tablet } from '@faxi/web-css-utilities';
import styled, { css } from 'styled-components';

const StyledValueCurrencyBox = styled.div`
  ${flex('column')};
  gap: ${theme.sizes.SIZE_20};

  .cedolauto-value-currency-box {
    &__container {
      ${flex('column')};
      gap: ${theme.sizes.SIZE_40};
      border-radius: ${theme.sizes.SIZE_8};
      border: ${theme.sizes.SIZE_4} solid var(--PRIMARY_1_1);
      padding: ${theme.sizes.SIZE_24};

      &__values {
        ${flex('column', 'center', 'center')};
        gap: ${theme.sizes.SIZE_12};

        > p {
          ${fontSize('28px')};
          color: var(--BACKGROUND_2_1);
          margin: 0;
          text-align: center;

          ${tablet(css`
            ${fontSize('18px')};
          `)}
        }

        &__value {
          ${fontSize('40px')};

          ${tablet(css`
            ${fontSize('25px')};
          `)}

          &--error {
            color: var(--RED-EB);
          }
        }

        > div {
          ${flex('row', 'center', 'center')};
          gap: ${theme.sizes.SIZE_12};
          color: var(--PRIMARY_1_1);

          .tippy-box[data-theme~='custom-tooltip'] {
            width: ${theme.sizes.SIZE_560};
            ${fontSize(theme.fontSizes.FONT_12)};
          }
        }
      }

      > p {
        ${fontSize('28px')};
        color: var(--BACKGROUND_2_1);
        margin: 0;
        text-align: center;
        ${tablet(css`
          ${fontSize('18px')};
        `)}
      }
    }
  }

  small {
    color: var(--BACKGROUND_2_1);
  }
`;

export { StyledValueCurrencyBox };
